export const ClearUser_UPDATE_REQUEST = "ClearUser_UPDATE_REQUEST";
export const ClearUser_UPDATE_SUCCESS = "ClearUser_UPDATE_SUCCESS";
export const ClearUser_UPDATE_FAILURE = "ClearUser_UPDATE_FAILURE";
export const ClearUser_UPDATE_RESET = "ClearUser_UPDATE_RESET";